export default __webpack_public_path__ + "static/media/MINI-journal-aqua.7d8ac1a9.jpg";